import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const authGuard: CanActivateFn = (route, state) => {
  
  let islogged = localStorage.getItem('token');
  const router = inject(Router)
  if (islogged) {
    return true;
  } else {
    router.navigate(['/signin']);
    return true;
  }

};
